// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FKGaO","icon":"_2exxby","return":"P6FIg9","section":"_16LZk_","date":"LKmGJ_"};